import * as React from "react";
import { Button } from "@/shared/components/ui/button";

type Props = React.ComponentProps<typeof Button> & { busy?: boolean };

export function BusyButton({ busy, children, disabled, ...rest }: Props) {
  return (
    <div className="flex justify-center">
      <Button disabled={busy || disabled} {...rest}>
        {busy ? (
          <>
            <span className="mr-2 inline-block h-5 w-5 animate-spin rounded-full border-4 border-[var(--secondary)] border-r-transparent" />
            Procesando...
          </>
        ) : (
          children
        )}
      </Button>
    </div>
  );
}
